import React, { useEffect, useRef, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import extractedIcon from '../../../assets/img/extracted-icon.svg';
import deleteBtn from '../../../assets/img/delete.svg';
import attechFile from '../../../assets/img/ios-attach.svg';
import filePic from '../../../assets/img/file-picture.svg';

import { calculateDays, extractScopeFromContract, selectLoader, sleep } from '../../../utils/Helpers';
import APIServices from '../../../services/APIServices';
import appToast, { TOAST_TYPE } from '../../../utils/AppToast';

import DeleteModal from '../../../components/DeleteModal';
import { useNavigate, useParams } from 'react-router-dom';

import SOWContractModal from 'components/SOWContractModal';
import UploadContractContent from 'components/UploadContractContent';
import SidebarModal from 'components/SidebarModal';
import rightArrowIcon from '../../../assets/img/right-arrow.svg';
import pdffileIcon from '../../../assets/img/pdffile.svg';
import clossIcon from '../../../assets/img/closs-icon23.svg';
import uploadIcon2 from '../../../assets/img/upload-icon2.svg';
import eyeIcon from '../../../assets/img/eye-icon.svg';
import downloadIcon2 from '../../../assets/img/downloadIcon2.svg';
import ConfirmModal from 'components/ConfirmModal';
import { useAuth } from 'contexts/AuthContext';
import UploadContractOnly from 'components/UploadContractOnly';

const ScopeOfWork = ({
  setprojectDetails,
  projectDetails,
  currentTab,
  setCurrentTab,
  setCompletedTabs,
  isWithContract,
  setWithContract,
  organizationsList,
  setInternalProject,
  isInternalProject,
  editProjectDetails,
  defaultTeam,
  permissions,
  contractPrefill,
  setContractPrefill,
  setContractUploaded
}) => {
  const navigate = useNavigate();
  const { user, inviterId } = useAuth();
  const { projectId: projectIdFromParams } = useParams();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [scopeLoadError, setScopeLoadError] = useState('');
  const [projectId, setProjectId] = useState('');
  const [project, setProject] = useState(null);
  const [scopeId, setScopeId] = useState('');
  const [scopeDetails, setScopeDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isEditing, setEditing] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [filesToDelete, setFilesToDelete] = useState([]);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [showContractModal, setShowContractModal] = useState(false);

  const [milestones, setMilestones] = useState([]);
  const [contractFile, setContractFile] = useState(null);
  const [contractFileDetails, setContractFileDetails] = useState(null);
  const [scopeText, setScopeText] = useState('');
  const [files, setFiles] = useState([]);
  const [isContractFlow, setIsContractFlow] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [contractUploadFile, setContractUploadFile] = useState(null);
  const [isUploadingFile, setUploadingFile] = useState(false);
  const [removeContract, setRemoveContract] = useState(false);
  const [isScopeExtracted, setScopeExtracted] = useState(false);
  const [organizationId, setOrganizationId] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const isMountedRef = useRef(true);
  const submissionInProgressRef = useRef(false);
  const scopeEditorRef = useRef(null);
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const focusScopeEditor = () => {
    const quill = scopeEditorRef.current?.getEditor?.();
    if (!quill) return;

    quill.focus();

    if (!quill.getSelection()) {
      const length = quill.getLength();
      quill.setSelection(Math.max(length - 1, 0), 0);
    }
  };

  const handleContractUploadFromUI = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    e.target.value = null;
    setUploadingFile(true);
    setSelectedFile(file);
    try {
      const res = await extractScopeFromContract(file);
      if (res == null || !isMountedRef.current) {
        return;
      }
      if (!isMountedRef.current) return;
      if (res?.message) {
        appToast(res.message, TOAST_TYPE.SUCCESS);
      }
      // if (res?.project) {
      //   setContractPrefill((prev) => ({
      //     ...prev,
      //     project: res.project
      //   }));
      // }

      if (res?.scope) {
        const formattedScope = res.scope
          .split('\n')
          .map((line) => `<p>${line}</p>`)
          .join('');

        setScopeText(formattedScope);

        setContractPrefill((prev) => ({
          ...prev,
          scope: formattedScope
        }));
      }

      if (res?.milestones) {
        setMilestones(res.milestones);

        setContractPrefill((prev) => ({
          ...prev,
          milestones: res.milestones
        }));
      }
      // store preview data before opening modal
      setContractUploadFile(file);

      // if (res?.scope) {
      //   const formattedScope = res.scope
      //     .split('\n')
      //     .map((line) => `<p>${line}</p>`)
      //     .join('');

      //   setScopeText(formattedScope);
      //   setScopeExtracted(true);
      // }

      // if (res?.milestones) {
      //   setMilestones(res.milestones);
      // }

      // open modal AFTER preview is ready
      setContractUploaded(true);
      // setShowContractModal(true);
      setShowPreviewModal(true);
    } catch (err) {
      console.error(err);
    } finally {
      setSelectedFile(null);
      setUploadingFile(false);
    }
  };

  useEffect(() => {
    if (contractPrefill?.scope) {
      setScopeText(contractPrefill.scope);
    }
    if (contractPrefill?.contractFile) {
      console.log(contractPrefill.contractFile, 'contractPrefill.contractFile');

      setContractFile(contractPrefill.contractFile);
      setContractUploadFile(contractPrefill.contractFile);
      setContractFileDetails(contractPrefill.contractFile);
      setContractUploaded(true);
    }
  }, [contractPrefill]);
  /* ---------------------------
      OPEN CONTRACT MODAL
  --------------------------- */

  useEffect(() => {
    if (isWithContract) {
      setShowUploadModal(true);
    }
  }, [isWithContract]);

  /* ---------------------------
      PROJECT ID
  --------------------------- */

  useEffect(() => {
    if (projectDetails) {
      setProjectId(projectDetails._id);
      setProject(projectDetails);
    } else if (projectIdFromParams) {
      setProjectId(projectIdFromParams);
      setEditing(true);
    }
  }, [projectDetails, projectIdFromParams, currentTab]);

  /* ---------------------------
      FETCH EXISTING SCOPE
  --------------------------- */

  useEffect(() => {
    if (isEditing && currentTab === 4) {
      fetchScopeDetails();
      setFilesToDelete([]);
      if (editProjectDetails) {
        setProject(editProjectDetails);
      }
    }
  }, [currentTab]);

  const fetchScopeDetails = async () => {
    setPageLoading(true);
    setScopeLoadError('');

    try {
      const response = await APIServices.get(`/project-scope?projectId=${projectId}`);
      setScopeDetails(response);
      if (response.scopeText) {
        setScopeText(response.scopeText);
      }
      if (response.contract) {
        setContractFileDetails(response.contract);
      }

      if (response.attachments) {
        setFiles(response.attachments);
      }

      setScopeId(response?._id);
    } catch (error) {
      console.error('Error fetching scope details:', error);
      const message = error?.message || 'Unable to load the scope of work. Please try again.';
      setScopeLoadError(message);
      appToast(message, TOAST_TYPE.ERROR);
    } finally {
      setPageLoading(false);
    }
  };

  /* ---------------------------
      FILE HANDLING
  --------------------------- */

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    e.target.value = '';

    const totalFiles = files.length + selectedFiles.length;

    if (totalFiles > 5) {
      appToast('You can upload a maximum of 5 files.', TOAST_TYPE.ERROR);
      return;
    }

    const existingSize = files.reduce((sum, file) => sum + (file.size || 0), 0);
    const newSize = selectedFiles.reduce((sum, file) => sum + file.size, 0);

    if (existingSize + newSize > 40 * 1024 * 1024) {
      appToast('The total size of uploaded files should not exceed 40MB.', TOAST_TYPE.ERROR);
      return;
    }

    setFiles((prev) => [...prev, ...selectedFiles]);
  };

  const handleRemoveFile = (index) => {
    const fileToDelete = files[index];

    if (isEditing && fileToDelete?._id) {
      setFilesToDelete((prev) => [...prev, fileToDelete._id]);
    }

    const updatedFiles = files.filter((_, i) => i !== index);
    setFiles(updatedFiles);
  };

  /* ---------------------------
  VALIDATION
  --------------------------- */

  const validateInputs = () => {
    const normalizedScopeText = (scopeText || '')
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;|&#160;|&#xA0;/gi, ' ')
      .replace(/&ZeroWidthSpace;|&#8203;|&#x200B;/gi, '')
      .replace(/[\s\u00a0\u200b-\u200d\ufeff]/g, '');

    if (!normalizedScopeText) {
      appToast('Scope of work is required.', TOAST_TYPE.ERROR);
      return false;
    }

    return true;
  };

  /* ---------------------------
      SUBMIT
  --------------------------- */

  const handleEditProject = (projectId) => {
    navigate(`/create-with-contract/${projectId}`);
  };

  const saveMilestones = async () => {
    if (!milestones?.length) return;

    const milestonePayload = milestones.map((milestone, index) => {
      const startDate = project.startDate;

      return {
        name: milestone.name,
        description: '',
        startDate,
        daysToComplete: milestone.dueDate ? calculateDays(milestone.dueDate) : 0,
        signOffTime: 0,
        signOffRequired: false,
        feedbackRequest: false,
        assigneeId: null,
        paymentDue: Number(milestone.paymentDue) || 0,
        paymentDueRequired: true,
        isProjectAndKanbanBoardCard: false,
        projectId,
        sequence: index + 1
      };
    });

    // await APIServices.put(`/project-milestone/${projectId}`, {
    //   milestones: milestonePayload
    // });
    await APIServices.post(`/project-milestone`, milestonePayload);

    setShowContractModal(false);
    setEditing(true);
    if (!isEditing) {
      if (!contractUploadFile) {
        setCurrentTab(1);
      } else {
        setCurrentTab(5);
      }
    }
  };

  const saveTeam = async () => {
    const endpoint = '/project-team';
    let contractTeam = [];
    let currentUser = defaultTeam.find((x) => x.value == user._id);
    let owner = defaultTeam.find((x) => x.roleName == 'owner');
    console.log(currentUser, owner);
    contractTeam = [currentUser, owner];
    console.log(contractTeam, 'contractTeam');

    // return;
    let currentPermission = permissions?.find((x) => x.label == 'Edit');
    // e.preventDefault();
    let payload = {
      projectId,
      organizationId: project.organizationId,
      myTeam: contractTeam.map((member) => {
        return {
          name: member.label,
          email: member?.email,
          role: member?.role,
          userId: member?.value,
          roleName: member?.roleName,
          permission: currentPermission?.value
        };
      }),
      organizationTeam: [],
      projectName: project.projectName
    };
    try {
      const response = isEditing ? await APIServices.put(endpoint, payload) : await APIServices.post(endpoint, payload);
      if (response) {
        console.log(response, 'response');
      }
    } catch (error) {
      console.log(error.message);
    }
    // Add your form submission logic here
  };

  const saveScope = async () => {
    const formData = new FormData();

    formData.append('projectId', projectId);
    formData.append('scopeText', scopeText);

    files.forEach((file) => {
      formData.append('attachments', file);
    });

    if (isEditing && filesToDelete.length > 0) {
      formData.append('deletedAttachments', filesToDelete.join(','));
    }

    if (contractFile) {
      formData.append('contract', contractFile);
    } else if (removeContract) {
      formData.append('deleteContract', true);
    }

    if (milestones?.length > 0) {
      formData.append('extractedMilestoneCount', milestones.length);
    }

    if (isEditing) {
      return await APIServices.put(`/project-scope/${scopeId}`, formData, {
        'Content-Type': 'multipart/form-data'
      });
    }

    return await APIServices.post(`/project-scope`, formData, {
      'Content-Type': 'multipart/form-data'
    });
  };

  const handleSubmit = async () => {
    if (submissionInProgressRef.current) return;

    if (!validateInputs()) return;

    submissionInProgressRef.current = true;
    setLoading(true);

    try {
      const response = await saveScope();

      if (!response?.projectId) {
        appToast(response?.message, TOAST_TYPE.ERROR);
        return;
      }

      setScopeId(response._id);

      setCurrentTab(5);
      setCompletedTabs((prev) => ({
        ...prev,
        [5]: true
      }));
      setEditing(true);
    } catch (error) {
      console.error('Scope save error:', error);
    } finally {
      submissionInProgressRef.current = false;
      setLoading(false);
      setUploadingFile(false);
    }
  };

  const ModalContent = (
    <div>
      <div className="contract-upload-wrapper">
        {loading ? (
          selectLoader(50)
        ) : (
          <div className="contract-upload-card text-center">
            <div className="upload-icon-wrap mb-3">
              <img src={uploadIcon2} alt="upload" width={40} className="uploadIcon2" />
            </div>

            <h5>Upload scope of work assets </h5>

            {/* <p className="text-muted">
                Upload your contract and we'll automatically extract the scope of work and milestones
              </p> */}

            <label className="btn btn-success">
              <img src={uploadIcon2} alt="upload" width={40} className="uploadIcon2-img" />
              Choose File
              <input
                type="file"
                multiple
                hidden
                accept=".pdf,.doc,.docx,.txt,.jpg,.png,.jpeg"
                onChange={handleFileChange}
              />
            </label>
            <p className="file-name">Supports PDF, DOC, DOCX, and TXT files</p>
          </div>
        )}
      </div>

      {files.map((file, index) => (
        <div className="user-box-cover" key={index}>
          <div className="username">
            <img src={filePic} alt="file" className="filePic" />

            <div className="username-content">
              <p>{file.name}</p>

              <small>{file.size ? `${(file.size / 1024).toFixed(2)} KB` : file.fileSize || ''}</small>
            </div>
          </div>

          <div className="group-icon-right">
            {/* Preview */}
            {isEditing && (
              <>
                <img
                  src={eyeIcon}
                  alt="preview"
                  className="eyeIcon cursor_pointer"
                  onClick={() => {
                    if (file.url) window.open(file.url, '_blank');
                  }}
                />

                {/* Download */}
                <img
                  src={downloadIcon2}
                  alt="download"
                  className="downloadIcon2 cursor_pointer"
                  onClick={() => {
                    if (file.url) window.open(file.url, '_blank');
                  }}
                />
              </>
            )}

            {/* Delete */}
            <img
              src={deleteBtn}
              alt="delete"
              className="deleteBtn cursor_pointer"
              onClick={() => handleRemoveFile(index)}
            />
          </div>
        </div>
      ))}
    </div>
  );

  const removeContractConfirmText = (
    <>
      <h2 className="mb-3">Are you sure?</h2>
      <h3>You want to remove this contract?</h3>
    </>
  );

  return (
    <div className="tabCover-container">
      <div className="scope-of-work mt-5">
        {pageLoading ? (
          <div className="nodata-loader">{selectLoader(70)}</div>
        ) : scopeLoadError ? (
          <div className="scope-load-error" role="alert">
            <h3>Unable to load Scope of Work</h3>
            <p>{scopeLoadError}</p>
            <button type="button" className="btn-black" onClick={fetchScopeDetails}>
              Retry
            </button>
          </div>
        ) : (
          <>
            {!contractFileDetails ? (
              <div className="contract-upload-wrapper">
                <div className="contract-upload-card text-center">
                  <div className="upload-icon-wrap mb-3">
                    <img src={uploadIcon2} alt="upload" width={40} className="uploadIcon2" />
                  </div>

                  <h5>{selectedFile ? selectedFile.name : 'Upload Contract for AI Extraction'}</h5>

                  <p className="text-muted">
                    Upload your contract and we'll automatically extract the scope of work and milestones
                  </p>

                  {isUploadingFile ? (
                    <label className="btn btn-success fetching-contract-loader">
                      {selectLoader(20)}
                      Parsing with AI
                      <input type="file" hidden accept=".pdf,.doc,.docx,.txt" disabled={true} />
                    </label>
                  ) : (
                    <label className="btn btn-success">
                      <img src={uploadIcon2} alt="upload" width={40} className="uploadIcon2-img" />
                      Choose Contract File
                      <input type="file" hidden accept=".pdf,.doc,.docx,.txt" onChange={handleContractUploadFromUI} />
                    </label>
                  )}

                  <p className="file-name">Supports PDF, DOC, DOCX, and TXT files</p>
                </div>
              </div>
            ) : (
              <div
                className="preview-milestonesCard-cover cursor_pointer"
                onClick={() => {
                  if (contractFileDetails?.url) {
                    window.open(contractFileDetails.url, '_blank');
                  }
                }}>
                <div className="pdf-content-left">
                  <div className="pdf-check">
                    <img src={extractedIcon} alt="extractedIcon" width={40} className="extractedIcon-pdf" />
                  </div>
                  {console.log(contractFileDetails, 'contractFileDetails')}

                  <div className="pdf-content">
                    <span>
                      <img src={pdffileIcon} alt="pdffileIcon" width={40} className="pdffileIcon-pdf" />
                      {contractFileDetails?.name}
                    </span>

                    <p>✓ Extracted scope of work and milestones</p>
                  </div>
                </div>

                <img
                  src={clossIcon}
                  alt="clossIcon"
                  width={40}
                  className="clossIcon cursor_pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowConfirm(true);
                  }}
                />
              </div>
            )}
            <form>
              <div className="preview-card" onMouseDownCapture={focusScopeEditor}>
                <div className="preview-header">
                  <p>Scope of Work</p>
                  {(isScopeExtracted || contractFile) && (
                    <span className="extracted-badge">
                      {' '}
                      <img src={extractedIcon} alt="extractedIcon" width={40} className="extractedIcon" /> Extracted
                      from contract
                    </span>
                  )}
                </div>

                <ReactQuill
                  ref={scopeEditorRef}
                  value={scopeText}
                  onChange={setScopeText}
                  placeholder="Write scope of work"
                  style={{
                    // maxHeight: '285px',
                    minHeight: '100px',
                    height: 'auto'
                  }}
                  className="contract-quill-editor scope-quill-editor"
                />
              </div>

              {/* Attachments */}

              <div className="mb-0">
                <div className="cardbg-form-group2">
                  <div className="attech-file-cover">
                    <label className="attech-btn" onClick={() => setSidebarOpen(true)}>
                      <img src={attechFile} alt="attach" className="attechFile" />
                      Attach Assets {files.length > 0 && `(${files.length})`}
                    </label>

                    <div className="btn-black-cover">
                      <button
                        className={`btn-black ${isUploadingFile ? 'opacity05 pointernone' : ''}`}
                        type="button"
                        onClick={handleSubmit}
                        disabled={isUploadingFile || loading}
                        aria-busy={loading}>
                        {!loading ? (isEditing ? 'Update' : 'Continue to Milestones') : selectLoader(20)}
                        {!loading && <img src={rightArrowIcon} alt="comp1" className="rightArrowIcon-arrow" />}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </>
        )}

        {/* Contract Upload Modal */}

        <SOWContractModal show={showUploadModal} onHide={() => setShowUploadModal(false)} title="Upload Contract">
          <UploadContractOnly
            onUploadSuccess={(file, extractedData) => {
              setContractUploadFile(file);

              // store extracted data
              setScopeText(extractedData.scope);
              setMilestones(extractedData.milestones);

              setShowUploadModal(false);
              setShowPreviewModal(true); // 👈 open preview modal
            }}
          />
        </SOWContractModal>
        <SOWContractModal show={showPreviewModal} onHide={() => setShowPreviewModal(false)} title="Preview Contract">
          <UploadContractContent
            initialFile={contractUploadFile}
            initialScope={scopeText}
            initialMilestones={milestones}
            onConfirm={(contract, reviewedScope, reviewedMilestones) => {
              setScopeText(reviewedScope);
              setMilestones(reviewedMilestones);
              setContractPrefill((prev) => ({
                ...prev,
                scope: reviewedScope,
                milestones: reviewedMilestones
              }));
              setContractFile(contract);
              const fileWithPreview = {
                file: contract,
                name: contract.name,
                url: URL.createObjectURL(contract)
              };

              setContractFileDetails(fileWithPreview);

              setShowPreviewModal(false);
            }}
          />
        </SOWContractModal>
        <SidebarModal
          extraClass={'assets_sidebar'}
          show={sidebarOpen}
          onHide={() => setSidebarOpen(false)}
          headerTitle={'Attach Assets'}>
          {ModalContent}
        </SidebarModal>
        <ConfirmModal
          show={showConfirm}
          onHide={() => {
            setShowConfirm(false);
          }}
          confirmationText={removeContractConfirmText}
          handleAction={() => {
            setContractFile(null);
            setContractFileDetails(null);

            setContractUploadFile(null);
            setScopeExtracted(false);
            setContractPrefill((prev) => ({
              ...prev,
              contractFile: null,
              scope: scopeText,
              milestones
            }));

            setShowConfirm(false);
            setRemoveContract(true);
          }}
          closeText="Yes"
          // loading={}
          bgClassname={'whitebgmodal'}
        />
      </div>
    </div>
  );
};

export default ScopeOfWork;
